// main.ts
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createRouter, createWebHashHistory } from 'vue-router'
import App from '@/App.vue'
import './style.css'
import { DEFAULT_BRUSH_SIZE } from '@/config/qs-brushDefaults'
import { cursorManager } from '@/utils/qs-cursorManager'
import { useCanvasStore } from '@/stores/qs-store-canvas'
import { useLayerStore } from '@/stores/qs-store-layers'
import { useToolStore } from '@/stores/qs-store-tools'
import DrawingPage from '@/pages/qs-page-DrawingPage.vue'

cursorManager.init(DEFAULT_BRUSH_SIZE)

const routes = [
  {
    path: '/',
    name: 'Drawing',
    component: DrawingPage
  },
  {
    path: '/panelreset',
    name: 'PanelReset',
    component: DrawingPage
  },
  {
    path: '/test',
    name: 'Test',
    component: { template: '<div>TEST ROUTE WORKS!</div>' }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
app.use(router)

const canvasStore = useCanvasStore()
const layerStore = useLayerStore()
const toolStore = useToolStore()

app.config.globalProperties.$canvasStore = canvasStore
app.config.globalProperties.$layerStore = layerStore
app.config.globalProperties.$toolStore = toolStore

app.mount('#app')